import { Button } from '@/components/ui/button'

export default function HeroSection({ title, subtitle, buttonText, onButtonClick, imageSrc, imageAlt }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary/5 to-background py-12 md:py-20">
      <div className="container relative z-10 mx-auto px-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:gap-12">
          <div className="text-center lg:text-right lg:w-1/2">
            <h1 className="text-3xl md:text-5xl font-bold tracking-tight">{title}</h1>
            <p className="mt-4 text-base md:text-lg text-muted-foreground">{subtitle}</p>
            <Button size="lg" className="mt-6" onClick={onButtonClick}>{buttonText}</Button>
          </div>
          <div className="mt-8 lg:mt-0 lg:w-1/2">
            <img src={imageSrc} alt={imageAlt} className="rounded-2xl shadow-xl w-full h-auto object-cover max-h-96" />
          </div>
        </div>
      </div>
    </section>
  )
}